// extracted by mini-css-extract-plugin
export var footer = "_rs-0";
export var inherit = "_rs-1";
export var input = "_rs-2";
export var modalContent = "_rs-3";
export var quillEditor = "_rs-4";
export var subtitle = "_rs-5";